import { Image } from "../image";
import { cn } from "../utils/cn";
import { getFirstChar } from "./utils";

interface Props {
  imageUrl?: string;
  alt: string;
  className?: string;
  fallback?: boolean;
  fallbackClassName?: string;
  borderColor?: string;
}

const defaultClassName = "w-full h-full rounded-xl";

export const Avatar = ({
  imageUrl,
  alt,
  className,
  fallback = true,
  fallbackClassName,
  borderColor,
}: Props) => {
  return (
    <div
      className={cn(defaultClassName, className, "relative overflow-hidden")}
      style={{ borderColor: borderColor }}
    >
      {imageUrl || !fallback ? (
        <Image
          src={imageUrl}
          alt={alt}
          className="absolute inset-0 w-full h-full"
        />
      ) : (
        <div
          className={cn(
            "absolute inset-0 w-full h-full bg-gradient-to-tr from-red-2 to-red-3 flex items-center justify-center",
          )}
        >
          <span
            className={cn("text-white text-2xl font-black", fallbackClassName)}
          >
            {getFirstChar(alt)}
          </span>
        </div>
      )}
    </div>
  );
};

Avatar.displayName = "Avatar";
